import { render, staticRenderFns } from "./AppointmentListGroupTitle.vue?vue&type=template&id=7310e47a&scoped=true"
import script from "./AppointmentListGroupTitle.vue?vue&type=script&lang=ts"
export * from "./AppointmentListGroupTitle.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentListGroupTitle.vue?vue&type=style&index=0&id=7310e47a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7310e47a",
  null
  
)

export default component.exports